import { getClient } from '@/lib/restClient';
import { KioskService } from '@/services/Kiosk/KioskService';
import {
  KioskAccount,
  StoreChangePasswordParams,
  StoreCreateParams,
  StoreDeleteParams,
} from '@/services/Kiosk/type';

const createStore = async (params: StoreCreateParams): Promise<unknown> => {
  const kioskService = new KioskService(getClient());
  return await kioskService.createStore(params);
};

const changePassword = async (
  params: StoreChangePasswordParams
): Promise<unknown> => {
  const kioskService = new KioskService(getClient());
  return await kioskService.changePassword(params);
};

const deleteStore = async (params: StoreDeleteParams): Promise<unknown> => {
  const kioskService = new KioskService(getClient());
  return await kioskService.deleteStore(params);
};

const getAccount = async (accountId: string): Promise<KioskAccount> => {
  const kioskService = new KioskService(getClient());
  return await kioskService.getAccount(accountId);
};

export { changePassword, createStore, deleteStore, getAccount };
